// extracted by mini-css-extract-plugin
export var header = "StrapiTextRenderer-module--header--d9844";
export var header5 = "StrapiTextRenderer-module--header5--eaf80";
export var image = "StrapiTextRenderer-module--image--9e325";
export var paragraph = "StrapiTextRenderer-module--paragraph--056a3";
export var paragraph___wide = "StrapiTextRenderer-module--paragraph___wide--dd907";
export var quote = "StrapiTextRenderer-module--quote--06f8c";